import { loadStates } from '@/lib/api/statesService'
import { loadRoleConfigLookup } from '@/features/auth/services/rolesConfigApi'

/**
 * Loads shared reference data once per session (Angular LoadState + LoadUserRoles).
 * Safe to call from multiple places — underlying services dedupe in-flight requests.
 */
export async function ensureReferenceDataLoaded(): Promise<void> {
  await Promise.all([loadStates(), loadRoleConfigLookup()])
}
